import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import PageContainer from '../components/layout/PageContainer'
import PageHeader from '../components/layout/PageHeader'
import { Megaphone, MessageSquare, Bell } from 'lucide-react'
import BroadcastTab from '../components/Communication/BroadcastTab'
import ChatTab from '../components/Communication/ChatTab'
import NotificationHistoryTab from '../components/Communication/NotificationHistoryTab'

export const CommunicationPage = () => {
    const [activeTab, setActiveTab] = useState<'broadcast' | 'chat' | 'history'>('chat')

    // Example role check: only admins can broadcast, but everyone can chat
    // Adjust based on your real role logic
    const { userRole } = useAuthStore()
    const location = useLocation()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const tab = params.get('tab')
        if (tab === 'history' || tab === 'broadcast' || tab === 'chat') {
            setActiveTab(tab)
        }
    }, [location.search])

    // check user role
    const canBroadcast = userRole === 'owner' || userRole === 'admin'

    return (
        <PageContainer>
            <PageHeader
                title="Comunicação"
                description="Central de mensagens e avisos da organização."
            />

            <div className="flex flex-col gap-6">
                {/* Tab Navigation */}
                <div className="flex space-x-1 bg-[#001c28]/5 p-2 rounded-2xl w-fit">
                    <button
                        onClick={() => setActiveTab('chat')}
                        className={`flex items-center space-x-2 px-6 py-3 rounded-xl text-sm font-black uppercase tracking-widest transition-all ${activeTab === 'chat'
                            ? 'bg-[#001c28] text-[#d4a94d] shadow-lg shadow-[#001c28]/20'
                            : 'text-[#001c28]/40 hover:bg-[#001c28]/5 hover:text-[#001c28]'
                            }`}
                    >
                        <MessageSquare size={16} />
                        <span>Chat Interno</span>
                    </button>

                    {canBroadcast && (
                        <button
                            onClick={() => setActiveTab('broadcast')}
                            className={`flex items-center space-x-2 px-6 py-3 rounded-xl text-sm font-black uppercase tracking-widest transition-all ${activeTab === 'broadcast'
                                ? 'bg-[#001c28] text-[#d4a94d] shadow-lg shadow-[#001c28]/20'
                                : 'text-[#001c28]/40 hover:bg-[#001c28]/5 hover:text-[#001c28]'
                                }`}
                        >
                            <Megaphone size={16} />
                            <span>Transmissão</span>
                        </button>
                    )}

                    <button
                        onClick={() => setActiveTab('history')}
                        className={`flex items-center space-x-2 px-6 py-3 rounded-xl text-sm font-black uppercase tracking-widest transition-all ${activeTab === 'history'
                            ? 'bg-[#001c28] text-[#d4a94d] shadow-lg shadow-[#001c28]/20'
                            : 'text-[#001c28]/40 hover:bg-[#001c28]/5 hover:text-[#001c28]'
                            }`}
                    >
                        <Bell size={16} />
                        <span>Históricos de Push</span>
                    </button>
                </div>

                {/* Tab Content */}
                <div className="">
                    {activeTab === 'broadcast' && <BroadcastTab />}
                    {activeTab === 'chat' && <ChatTab />}
                    {activeTab === 'history' && <NotificationHistoryTab />}
                </div>
            </div>
        </PageContainer>
    )
}
